import { SVGProps } from "react";

const SuitecaseIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 8.67297H6.2002C5.08009 8.67297 4.51962 8.67297 4.0918 8.89096C3.71547 9.08271 3.40973 9.38845 3.21799 9.76477C3 10.1926 3 10.7531 3 11.8732V17.4732C3 18.5933 3 19.153 3.21799 19.5809C3.40973 19.9572 3.71547 20.2635 4.0918 20.4552C4.5192 20.673 5.07899 20.673 6.19691 20.673H17.8031C18.921 20.673 19.48 20.673 19.9074 20.4552C20.2837 20.2635 20.5905 19.9572 20.7822 19.5809C21 19.1535 21 18.5945 21 17.4766V11.8699C21 10.752 21 10.1922 20.7822 9.76477C20.5905 9.38845 20.2837 9.08271 19.9074 8.89096C19.4796 8.67297 18.9203 8.67297 17.8002 8.67297H16M8 8.67297H16M8 8.67297C8 6.46383 9.79086 4.67297 12 4.67297C14.2091 4.67297 16 6.46383 16 8.67297"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SuitecaseIcon;
